/**
 * USDX DEX deployment — Base Sepolia (chain ID 84532).
 *
 * Uniswap-V2-style deployment. Verified on-chain against this factory:
 *   router.factory() === factoryAddress
 *   router.WETH()    === WETHAddress
 *
 * Deployer / feeTo / feeToSetter: 0x26aBD5b55B8b02FcC3037A1B0B0E9E99C19106c8
 *
 * NOTE: Base Sepolia is a TESTNET. When the mainnet deployment lands, repoint
 * these three addresses, swap `baseSepolia` for `base` in Header.js and
 * contexts/thirdWebClient.js, update CHAIN_ID to 8453, set NETWORK_LABEL to
 * "Base", and replace the mock tokens in SelectTokenDATA.js.
 */

export const CHAIN_ID = 84532;

export const routerAddress = "0xc1285e62d5728BA6baCa085247C181E409A1F603";
export const factoryAddress = "0x3B48CdDCdA3C4ca345fF5Ef176f3B65bCCD02A69";
export const WETHAddress = "0x4200000000000000000000000000000000000006";

/** Fee recipient configured on the factory. */
export const feeTo = "0x26aBD5b55B8b02FcC3037A1B0B0E9E99C19106c8";

/** Network name shown throughout the UI. Matches the chain actually in use. */
export const NETWORK_LABEL = "Base Sepolia";

/** Public RPC for read-only calls when the wallet does not supply one. */
export const RPC_URL = "https://sepolia.base.org";

/** Base mainnet's chain ID — the one value that decides the two flags below. */
const BASE_MAINNET_ID = 8453;

/** True while the app points at a test network. Derived, so flipping CHAIN_ID
 *  above is enough — nothing else has to be remembered. */
export const IS_TESTNET = CHAIN_ID !== BASE_MAINNET_ID;

/** Block explorer for the configured chain, for linking contracts and txs. */
export const EXPLORER_URL = IS_TESTNET
    ? "https://sepolia.basescan.org"
    : "https://basescan.org";
